<!-- Display list of Tags as chips with a 'matching because of:' hint beforehand. -->
<template>
  <v-layout
    wrap
    align-baseline
    style="line-height: normal"
  >
    <!-- Respecting Tag-activation hint -->
    <div
      v-if="tagEntryActive && $vuetify.breakpoint.smAndUp"
      class="caption mr-2 mb-1"
      :class="[textClass]"
    >
      {{ $t('tagsContentIsActiveBecauseOfMatchingTags') }}
    </div>
    <!-- Ignoring Tag-activation hint -->
    <div
      v-if="!tagEntryActive"
      class="caption mr-2"
      :class="{'mb-1': $vuetify.breakpoint.xs}"
    >
      <div class="mb-1">
        <v-icon
          small
          color="warning"
        >
          block
        </v-icon>
        <span
          v-if="$vuetify.breakpoint.smAndUp"
          class="warning--text"
        >{{
          $t('tagsContentIsDeactivatedIgnoringMatchingTags')
        }}</span>
        <span
          v-else
          class="warning--text"
        >{{
          capitalize($t('deactivated'))
        }}</span>
      </div>
      <div
        class="grey--text text--darken-2 pseudo-anchor--inverted unselectable"
        @click="$emit('reactivate')"
      >
        <v-icon small>
          play_arrow
        </v-icon>
        {{ $t('reactivate') }}
      </div>
    </div>
    <div class="mb-1">
      <tag-list
        :tags="matchingTags"
        :xs="xs"
        data-cy="matching-tags-list"
      />
    </div>
  </v-layout>
</template>

<script>
import {capitalize} from '@/utils';

import TagList from '@/components/TagList';

export default {
  components: {
    TagList,
  },
  props: {
    matchingTags: {
      type: Array,
      required: true,
    },
    tagEntryActive: {
      type: Boolean,
      required: true,
    },
    xs: {
      type: Boolean,
      default: true,
    },
    textClass: {
      type: String,
      default: 'grey--text text--darken-1',
    },
  },
  methods: {
    capitalize: capitalize,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MatchingTags.vue